import React, { FunctionComponent } from 'react';

import Fab from '@gojob/ui-bits/Fab';
import Facebook from '@gojob/ui-bits/Footer/assets/Facebook';
import Instagram from '@gojob/ui-bits/Footer/assets/Instagram';
import Linkedin from '@gojob/ui-bits/Footer/assets/Linkedin';
import Twitter from '@gojob/ui-bits/Footer/assets/Twitter';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import BCorpLogo from './BCorpLogo';
import Section from './Section';

export type SocialProps = {
  socialLinks: {
    facebookLink?: string;
    instagramLink?: string;
    linkedInLink?: string;
    twitterLink?: string;
  };
};

type SocialLinkProps = {
  href?: string;
  'aria-label'?: string;
};
const SocialLink: FunctionComponent<SocialLinkProps> = (props) => {
  return <Fab as="a" color="primary" target="_blank" {...props} />;
};

const Social: FunctionComponent<SocialProps> = (props) => {
  const { socialLinks } = props;
  const { spacing } = useTheme();

  return (
    <Section>
      <div
        css={{
          margin: spacing(2.5, 0),
          display: 'flex',
          flexDirection: 'column',
          gap: spacing(2),
          width: 'min-content',
        }}
      >
        <div css={{ display: 'flex', gap: spacing(2.5) }}>
          {socialLinks.facebookLink ? (
            <SocialLink href={socialLinks.facebookLink} aria-label="Facebook">
              <Facebook />
            </SocialLink>
          ) : null}

          {socialLinks.linkedInLink ? (
            <SocialLink href={socialLinks.linkedInLink} aria-label="LinkedIn">
              <Linkedin />
            </SocialLink>
          ) : null}

          {socialLinks.instagramLink ? (
            <SocialLink href={socialLinks.instagramLink} aria-label="Instagram">
              <Instagram />
            </SocialLink>
          ) : null}

          {socialLinks.twitterLink ? (
            <SocialLink href={socialLinks.twitterLink} aria-label="Twitter">
              <Twitter />
            </SocialLink>
          ) : null}
        </div>
        <div css={{ display: 'flex', justifyContent: 'center', padding: spacing(1.5) }}>
          <BCorpLogo css={{ height: spacing(20) }} />
        </div>
      </div>
    </Section>
  );
};

export default Social;
